import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";

import OnboardingApp from "./pages/OnboardingApp";
import HelpPage from "./pages/HelpPage";
import ProductPage from "./pages/ProductPage";
import ContactPage from "./pages/ContactPage";

function App() {
  // Detect if running inside an iframe
  const isInIframe = window.self !== window.top;
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        {!isInIframe && <Header />}
        <main className="flex-grow" style={{ backgroundColor: '#ffffff' }}>
          <Routes>
            <Route path="/" element={<OnboardingApp />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        {!isInIframe && <Footer />}
      </div>
    </BrowserRouter>
  );
}

export default App;